let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9VEIz")).then(() => parcelRequire('8u8jr'));